export async function eSha256(cadena){
    const CryptoJS = require('crypto-js');

    const hash = CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(cadena));
    const cadenaEncriptada = hash.toString(CryptoJS.enc.Hex).toUpperCase();
    return cadenaEncriptada;
}

export function eB64(cadena) { 
    // return window.btoa(encodeURIComponent(cadena));
    const CryptoJS = require('crypto-js');

    try{        
        const cadenaEncriptada = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(cadena));
        return cadenaEncriptada;
    }catch(error){
        console.log("Erro al encriptar base64");
    }
}

export function dB64(cadenaEncriptada){
    // return decodeURIComponent(window.atob(cadenaEncriptada));
    const CryptoJS = require("crypto-js");

    try{
        const cadenaDesencriptada = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(cadenaEncriptada));
        return cadenaDesencriptada;
    }catch(error){
        console.log("Error al desencriptar base64");
    }
}